import { defineMessages } from 'react-intl'

export const PageTitleMessages = defineMessages({
  suffix: {
    id: 'PageTitle.suffix',
    description: 'The "Pre-Qualifier | LendCare" portion of every page title',
  },
  home: {
    id: 'PageTitle.home',
    description: 'Fallback page label when no route matches',
  },
  loading: {
    id: 'PageTitle.loading',
    description: 'Page label for loading / route-resolver screens',
  },
  processing: {
    id: 'PageTitle.processing',
    description: 'Page label for post-submission processing screens',
  },
  submitting: {
    id: 'PageTitle.submitting',
    description: 'Page label for the auto-submit step',
  },
  selectAssetType: {
    id: 'PageTitle.selectAssetType',
    description: 'Page label for the asset-type selection screen',
  },
  verifyIdentity: {
    id: 'PageTitle.verifyIdentity',
    description: 'Page label for the consumer authentication screen',
  },
  approved: {
    id: 'PageTitle.approved',
    description: 'Page label for the post-submission approval screen',
  },
  yourOffers: {
    id: 'PageTitle.yourOffers',
    description: 'Page label for the post-submission offers screen',
  },
  noOfferAvailable: {
    id: 'PageTitle.noOfferAvailable',
    description: 'Page label for the no-offer-available screen',
  },
  somethingWentWrong: {
    id: 'PageTitle.somethingWentWrong',
    description: 'Page label for the submission-error screen',
  },
  merchantSelected: {
    id: 'PageTitle.merchantSelected',
    description: 'Page label for the merchant-selection success screen',
  },
  selectMerchant: {
    id: 'PageTitle.selectMerchant',
    description: 'Page label for the merchant-selection screen',
  },
  unsubscribe: {
    id: 'PageTitle.unsubscribe',
    description: 'Page label for the offer-unsubscribe landing screen',
  },
  unsubscribed: {
    id: 'PageTitle.unsubscribed',
    description: 'Page label for the offer-unsubscribe success screen',
  },
  unsubscribeError: {
    id: 'PageTitle.unsubscribeError',
    description: 'Page label for the offer-unsubscribe error screen',
  },
  reviewAsset: {
    id: 'PageTitle.reviewAsset',
    description: 'Page label for the review-asset workflow step',
  },
  yourName: {
    id: 'PageTitle.yourName',
    description: 'Page label for the consumer-name workflow step',
  },
  phoneNumber: {
    id: 'PageTitle.phoneNumber',
    description: 'Page label for the consumer-phone workflow step',
  },
  verifyPhone: {
    id: 'PageTitle.verifyPhone',
    description: 'Page label for the phone-validation workflow step',
  },
  assetDetails: {
    id: 'PageTitle.assetDetails',
    description: 'Page label for the asset-subtype workflow step',
  },
  dateOfBirth: {
    id: 'PageTitle.dateOfBirth',
    description: 'Page label for the date-of-birth workflow step',
  },
  yourAddress: {
    id: 'PageTitle.yourAddress',
    description: 'Page label for the address workflow step',
  },
  emailAddress: {
    id: 'PageTitle.emailAddress',
    description: 'Page label for the email workflow step',
  },
  netIncome: {
    id: 'PageTitle.netIncome',
    description: 'Page label for the net-income workflow step',
  },
  reviewAndSubmit: {
    id: 'PageTitle.reviewAndSubmit',
    description: 'Page label for the consumer-submit workflow step',
  },
})
